import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../data/organizacion';
import { grafoInstitucional } from '../data/schema';

const OG_IMAGE_POR_DEFECTO = '/images/Logo.png';

/**
 * Metadatos por ruta + JSON-LD.
 *
 * El grafo institucional se emite en todas las páginas y cada una suma sus
 * propios nodos vía `jsonLd`, enlazados por `@id` contra el grafo base. El
 * prerender (scripts/prerender.js) deja todo esto en el HTML estático, así que
 * un crawler sin JS lo ve igual.
 */
const SEO = ({ title, description, path, image, jsonLd, noindex = false }) => {
  const canonical = `${SITE_URL}${path}`;
  const ogImage = `${SITE_URL}${image || OG_IMAGE_POR_DEFECTO}`;

  const nodos = [
    ...grafoInstitucional(),
    ...(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []),
  ];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:image" content={ogImage} />

      <script type="application/ld+json">
        {JSON.stringify({ '@context': 'https://schema.org', '@graph': nodos })}
      </script>
    </Helmet>
  );
};

export default SEO;
